/* eslint-disable camelcase */
import { IUserState } from '../../redux/user/user.initial-state';
import { User } from './user.types';

class UserParsingService {
  private static instance: UserParsingService | undefined;

  static getInstance(): UserParsingService {
    if (!UserParsingService.instance) {
      UserParsingService.instance = new UserParsingService();
    }

    return UserParsingService.instance;
  }

  parseUserApiData(payload: {user: User, access: string, refresh: string}): Partial<IUserState> {
    const {
      email, ext_user_id, first_name, fullname, last_name, permissions, user_details, organization, clients,
    } = payload.user;
    return {
      access: payload.access,
      email,
      extUserId: ext_user_id,
      firstName: first_name,
      fullname: fullname,
      isSuperAdmin: permissions?.groups?.includes('org_admin'), // TODO set to false
      lastName: last_name,
      permissions,
      user_details,
      organization,
      clients,
    };
  }

  // parseUserSubscription(json?: B2BSubscriptionJSON): UserSubscription | undefined {
  //   if (!json) {
  //     return undefined;
  //   }

  //   return {
  //     isInvoice: json.invoice,
  //   };
  // }
}

export default UserParsingService.getInstance();
